import React, { useContext } from "react"
import PropTypes from "prop-types"


import { Card } from "components/anti/card/card"

export const NavBottom = ({
  lang,
  prevTitle,
  prevImg,
  prevLink,
  nextTitle,
  nextImg,
  nextLink,
  className,
}) => {
  return (
    <div className={`nav-bottom ${className} pb-5 pb-md-0`}>
      <div className="row row-0">
        <div className="col-6">
          <Card
            variant="overlay"
            label={lang === "en" ? "Previous" : "Sebelumnya"}
            title={prevTitle}
            img={prevImg}
            imgHeight="img-height"
            imgRatio="r-5-4 r-md-16-9"
            link={prevLink}
            className="nav-bottom-item prev px-0"
            cardBodyClassName="px-1 py-0 p-md-3 px-sm-down-3"
            titleClassName="w-sm-down-150px text-truncate mb-4 text-right"
            labelClassName="font-weight-bold"
          />
        </div>
        <div className="col-6">
          <Card
            variant="overlay"
            label={lang === "en" ? "Next" : "Selanjutnya"}
            title={nextTitle}
            img={nextImg}
            imgHeight="img-height"
            imgRatio="r-5-4 r-md-16-9"
            link={nextLink}
            className="nav-bottom-item next"
            cardBodyClassName="px-1 py-0 p-md-3 px-sm-down-3"
            titleClassName="w-sm-down-150px text-truncate mb-4"
            labelClassName="font-weight-bold"
          />
        </div>
      </div>
    </div>
  )
}

NavBottom.propTypes = {
  prevTitle: PropTypes.string, // Set previous title
  prevImg: PropTypes.any, // Set previous image
  prevLink: PropTypes.string, // Set previous link / href
  nextTitle: PropTypes.string, // Set next title
  nextImg: PropTypes.any, // Set next image
  nextLink: PropTypes.string, // Set next link / href
  className: PropTypes.string, // Set cover optional classes
  children: PropTypes.any,
}

NavBottom.defaultProps = {
  prevLink: "",
  nextLink: "",
  className: "",
}
